import { render } from "./ProcessRequest.vue?vue&type=template&id=6a65895f&scoped=true"
import script from "./ProcessRequest.vue?vue&type=script&lang=js"
export * from "./ProcessRequest.vue?vue&type=script&lang=js"

import "./ProcessRequest.vue?vue&type=style&index=0&id=6a65895f&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a65895f"]])

export default __exports__